<template>
  <div>
    <ul
      class="flex space-x-10 mb-6 vault-nav"
      :class="{
        ['vault-nav-' + daoPageInfo.vueState.customClass]:
          daoPageInfo.isCustom.value,
      }"
      style="border-bottom: 1px solid #ffffff1a"
    >
      <li
        v-for="(text, i) in daoPageInfo.vueState.info.mirrorUrl
          ? ['Twitter Feed', 'Mirror']
          : ['Twitter Feed']"
        class="relative"
        @click="state.selected = i"
        :class="{
          active: state.selected == i,
        }"
        :key="i"
      >
        <div
          class="flex items-center cursor-pointer font-bold h-12 transition-all"
          :class="{
            'text-whitebase': state.selected == i,
            ' text-gray-level': state.selected != i,
          }"
        >
          {{ text }}
        </div>
      </li>
    </ul>

    <div
      class="flex items-center justify-center h-20"
      v-if="
        !daoPageInfo.vueState.info.isTwitterOauth &&
        (daoPageInfo.vueState.info.createId == userInfo.id ||
          daoPageInfo.vueState.info?.adminIds?.indexOf(userInfo.id) !== -1) &&
        state.selected == 0
      "
    >
      <div
        class="text-xs h-8 flex items-center px-4 cursor-pointer"
        style="
          box-shadow: 8px 45px 32px 0px rgba(0, 0, 0, 0.4);
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.4);
          backdrop-filter: blur(16px);
          width: fit-content;
        "
        @click="doGrant(daoPageInfo.vueState.info.name)"
      >
        <i class="iconfont icon-Twitter mr-1"></i> Verify Account
      </div>
    </div>

    <div
      v-if="daoPageInfo.vueState.info.twitter"
      class="relative"
      style="min-height: 360px"
      :class="{
        ' hidden': state.selected != 0,
      }"
    >
      <div
        class="relative z-10"
        :class="{
          'bg-white': !daoPageInfo.isCustom.value,
          [daoPageInfo.vueState.customClass === 'ape'
            ? 'bg-ape-back'
            : 'bg-aavegotchi-back']: daoPageInfo.isCustom.value,
        }"
      >
        <a
          class="twitter-timeline"
          :href="daoPageInfo.vueState.info.twitter"
          data-chrome="transparent noscrollbar nofooter noheader noborders"
          data-theme="dark"
        >
          <div
            class="flex px-4 w-full mb-4 mt-2"
            style="max-width: 640px; z-index: -1"
          >
            <Skeletor class="w-12 h-12 mr-4"></Skeletor>
            <div class="flex-1 space-y-2">
              <Skeletor class="rounded-sm"></Skeletor>
              <Skeletor class="rounded-sm"></Skeletor>
              <Skeletor class="rounded-sm"></Skeletor>
              <div></div>
              <Skeletor class="h-60 rounded-lg"></Skeletor>
            </div></div
        ></a>
      </div>
    </div>
    <div v-else class="flex items-center justify-center">
      <img
        src="@/assets/bgs/no_data.avif"
        alt="no daos data found"
        class="relative"
      />
      <div class="text-white-040 absolute">No Data</div>
    </div>

    <div :class="{ ' hidden': state.selected != 1 }">
      <div v-if="isEmpty" class="flex items-center justify-center">
        <img
          src="@/assets/bgs/no_data.avif"
          alt="no daos data found"
          class="relative"
        />
        <div class="text-white-040 absolute">No Data</div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4">
        <div
          v-for="(item, i) in results"
          :key="i"
          class="bg-white-005 rounded px-6 py-8 cursor-pointer"
          @click="state.selectMirror = item"
        >
          <div
            class="font-bold text-secondary-7 pb-14"
            style="border-bottom: 1px solid #ffffff1a"
          >
            {{ item.title }}
          </div>
          <div
            class="text-xs bg-white-005 rounded-full px-2 my-4"
            style="color: #ffffff66; width: fit-content"
          >
            {{ formatDate(item.createdTime * 1000, 'MMM DD,YYYY') }}
          </div>
          <div
            class="relative overflow-hidden w-full text-xs mb-4"
            style="height: 124px"
          >
            {{ item.body }}

            <div
              class="w-full h-full absolute top-0 left-0 mask-gradient"
            ></div>
          </div>
          <div
            class="text-xs bg-white-005 rounded-full px-2"
            style="color: #ffffff66; width: fit-content"
          >
            {{ formatAddress(item.contributor, 4) }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <Dialog
    :visible="!!state.selectMirror"
    @close="state.selectMirror = null"
    boxStyle="width:996px;transform: translate(-50%, -50%);"
  >
    <div class="text-whitebase">
      <div class="mt-8 text-secondary-7 font-bold text-xl">
        {{ state.selectMirror.title }}
      </div>
      <div class="flex my-4">
        <div
          class="text-xs bg-white-005 rounded-full px-2"
          style="color: #ffffff66; width: fit-content"
        >
          {{ formatAddress(state.selectMirror.contributor, 4) }}
        </div>
        <div
          class="text-xs bg-white-005 rounded-full px-2"
          style="color: #ffffff66; width: fit-content"
        >
          {{ formatDate(state.selectMirror.createdTime * 1000, 'MMM DD,YYYY') }}
        </div>
      </div>
      <div class="h-96 overflow-y-scroll">
        {{ state.selectMirror.body }}
      </div>
      <div class="mt-4">
        <a
          :href="`https://mirror.xyz/${state.selectMirror.contributor}/${state.selectMirror.digest}`"
          target="_blank"
          class="text-secondary-7 flex items-center"
        >
          <UiImg
            :src="require('@/assets/linkicon/mirror.avif')"
            class="w-8 h-8 mr-2"
          ></UiImg>
          Mirror
        </a>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { queryOvMirror, twVerify, twVerifyByPath } from '@/api/dao';
import { useReqByBool, useReqPages, useUserInfo } from '@/hooks';
import { formatDate, formatAddress } from '@/utils';
import { useInfiniteScroll } from '@vueuse/core';
import { tr } from 'date-fns/locale';
import { inject, reactive, onMounted, watch } from 'vue';
import { Skeletor } from 'vue-skeletor';
import Dialog from '@/components/Dialog.vue';
import UiImg from '@/components/UiImg.vue';
import { withThrottling } from '@/utils/with';
import { useRoute } from 'vue-router';

const daoPageInfo = inject('daoPageInfo');
const $route = useRoute();
const userInfo = useUserInfo();

const state = reactive({
  selected: 0,
  selectMirror: null,
});

const loadTw = async () => {
  try {
    // eslint-disable-next-line no-undef
    await twttr.widgets.load();
  } catch (error) {
    state.error = true;
  }
};

const { loadNext, loadRest, loading, results, isEmpty } = useReqPages(
  async (page, cancel) => {
    const res = await queryOvMirror(daoPageInfo.vueState.info.id, page, cancel);

    console.log(res.records);
    const result = {
      lists: res.records,
      rows: res.size,
      total: res.total,
      pages: res.pages,
    };
    return result;
  },
);

watch(
  () => state.selected,
  (val) => {
    if (val) {
      loadRest(true);
    }
  },
);

const doGrant = withThrottling(async (name) => {
  const link = await twVerifyByPath(
    $route.params.name,
    `${window.location.origin}/twoauth/${name}`,
  );
  window.location.href = link;
});

useInfiniteScroll(window, withThrottling(loadNext), { distance: 44 });

onMounted(() => {
  loadTw();
});
</script>

<style lang="scss" scoped>
.vault-nav li div:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 0%;
  background: #ff5585ff;
  transition: all 0.3s;
}
.vault-nav-aavegotchi li div:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 0%;
  background: #fa34f2ff;
  transition: all 0.3s;
}
.vault-nav-ape li div:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 0%;
  background: #0623cbff;
  transition: all 0.3s;
}
.vault-nav li.active div:before {
  width: 100%;
}
.mask-gradient {
  background: linear-gradient(180deg, rgba(30, 31, 33, 0) 0%, #1e1f21 100%);
}
</style>
